import z from 'zod'
import type { FeatureCollection } from 'geojson'
import { GeometrySchema } from '../../../@shared/infra/schemas/Geometry.schema'
import { FarmMapDto } from '../../domain/dtos/FarmMap.dto'

const FeatureSchema = z.preprocess(
	(val) => (typeof val === 'string' ? JSON.parse(val) : val),
	z.object({
		type: z.literal('Feature'),
		geometry: GeometrySchema,
		properties: z.any(),
	}),
)

const FeatureCollectionSchema = z.preprocess(
	(val) => (typeof val === 'string' ? JSON.parse(val) : val),
	z.object({
		type: z.literal('FeatureCollection'),
		features: z.array(FeatureSchema),
	}),
)

export const FarmMapSchema = z
	.object({
		result: z.object({
			fazenda: FeatureSchema,
			talhoes: FeatureCollectionSchema.nullable(),
			plantios: FeatureCollectionSchema,
		}),
	})
	.transform(
		(data): FarmMapDto => ({
			fazenda: data.result.fazenda as unknown as FeatureCollection,
			talhoes: (data.result.talhoes as unknown as FeatureCollection) ?? null,
			plantios: data.result.plantios as unknown as FeatureCollection,
		}),
	)
